import type { FC } from 'react'
import { wrap } from '../../../../../utils/globalUtils'
import { ImageSwiperView } from './ImageSwiperView'
import { useImageSwiper } from '../../hooks/useImageSwiper'
import type { ImageSwiperHookProps } from '../../types'

export const ImageSwiper: FC<ImageSwiperHookProps> = wrap(
    ImageSwiperView,
    useImageSwiper,
)
